import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  setThemeImageUrl,
  setThemeImageUrlSend,
  setThemePopup,
} from "../../../Redux/Actions/VideoHighlightAction";
import { TextField } from "@mui/material";
import styles from "./video-highlight.module.css";

export default function ThemeDialog() {
  const [title, setTitle] = useState("Title");
  const [subtitle, setSubtitle] = useState("Subtitle");
  const {
    themePopup,
    themeImageUrl,
    themeHighlightTitleColor,
    themeImageUrlSend,
  } = useSelector((state) => state?.videoHighlightData);
  const dispatch = useDispatch();

  const handleClose = async () => {
    setThemePopup(dispatch, false);
  };

  const handleCancel = () => {
    setThemePopup(dispatch, false);
  };

  const handleApplyTheme = () => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = themeImageUrl.split("_")[0] + "_apply.png";
    img.onload = () => {
      canvas.width = 960;
      canvas.height = 539;
      context.drawImage(img, 0, 0, 960, 539);
      context.font = "bold 75px Arial";
      context.fillStyle = `${themeHighlightTitleColor}`;
      context.fillText(title, 70, 250);
      context.font = "30px Arial";
      context.fillStyle = `${themeHighlightTitleColor}`;
      context.fillText(subtitle, 80, 290);
      const customizedThemeImageUrl = canvas.toDataURL("image/png");
      setThemeImageUrlSend(dispatch, customizedThemeImageUrl);
    };
  };
  return (
    <Dialog open={themePopup} onClose={handleClose}>
      <DialogTitle>Theme</DialogTitle>
      <DialogContent>
        <div className={`${styles.themeDialogImage}`}>
          <img
            src={themeImageUrlSend ? themeImageUrlSend : themeImageUrl}
            alt="contendzone"
            className={`${styles.themeImageSize}`}
          />
        </div>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", gap: "15px" }}>
        <TextField
          size="small"
          id="outlined-basic"
          label="Title"
          variant="outlined"
          autoFocus
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          size="small"
          id="outlined-basic"
          label="Subtitle"
          variant="outlined"
          autoFocus
          type="text"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
        />
        <Button
          sx={{ backgroundColor: "#002244" }}
          variant="contained"
          onClick={() => handleApplyTheme()}
        >
          Preview
        </Button>
        <Button
          sx={{ backgroundColor: "#002244" }}
          variant="contained"
          onClick={handleCancel}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}
